<template>
	<section>
		<div class="custom-topbar">
			<div class="badge mode-indicator">
				<i class="fas fa-cog" :class="{'fa-pulse': type === 'realtime'}"></i> 
				Modo de Dados:
				<span v-if="type === 'realtime'" class="realtime">Tempo Real</span>
				<span v-else class="report">Relatório</span>
			</div>
			<div>
				<b-button variant="success" @click="generateExcel()" :disabled="excelLoading">
					<span v-if="!excelLoading">
						<i class="fas fa-clipboard"></i> Exportar para Excel
					</span>
					<span v-else>
						<i class="fas fa-spinner fa-pulse"></i> Gerando arquivo...
					</span>
				</b-button>
				<b-button v-b-toggle.collapse-dashboard-filters variant="primary">
					<i class="fas fa-filter"></i> Filtros
				</b-button>
			</div>
		</div>

		<div class="collapse-wrapper">
			<b-collapse id="collapse-dashboard-filters" class="filters-collapse">
				<b-card class="filters-card">
					<div class="filters-content">
						<div class="filter-group">
							<div class="filter-checkbox-group">
								<span>Projetos</span>
								<div class="checkbox-input-group">
									<input type="checkbox" v-model="selectAllProjects"></input>
									<span>Selecionar todas</span>
								</div>
							</div>
							<multiselect v-model="selectedProjects" :options="projectsList" :multiple="true" :close-on-select="false"
								:clear-on-select="false" select-label="Selecionar" deselect-label="Remover" selected-label="Selecionado"
								:preserve-search="true" placeholder="Selecione os projetos" label="name" track-by="id"
								:preselect-first="false" :searchable="true" style="font-size: 12px;">
								<template slot="selection" slot-scope="{ isOpen }">
									<span class="multiselect__single"
										v-if="selectedProjects.length"
										v-show="!isOpen">{{ selectedProjects.length }} {{ selectedProjects.length === 1 ? 'projeto selecionado' : 'projetos selecionados' }}
									</span>
								</template>
							</multiselect>
						</div>

						<div class="filter-group">
							<div class="filter-checkbox-group">
								<span>Filas de telefonia</span>
								<div class="checkbox-input-group">
									<input class="form-control" type="checkbox" v-model="selectAllPhoneQueues"></input>
									<span>Selecionar todas</span>
								</div>
							</div>
							<multiselect v-model="selectedQueues" :options="queuesList" :multiple="true" :close-on-select="false"
								:clear-on-select="false" select-label="Selecionar" deselect-label="Remover" selected-label="Selecionada"
								:preserve-search="true" placeholder="Selecione as filas" label="name" track-by="id"
								:preselect-first="true" :searchable="true" style="font-size: 12px;">
								<template slot="selection" slot-scope="{ values, search, isOpen }">
									<span class="multiselect__single"
										v-if="selectedQueues.length" 
										v-show="!isOpen">{{ selectedQueues.length }} {{ selectedQueues.length === 1 ? 'fila selecionada' : 'filas selecionadas' }}
									</span></template>
							</multiselect>
						</div>
						<div class="filter-group">
							<div class="filter-checkbox-group">
								<span>Filas de chat</span>
								<div class="checkbox-input-group">
									<input class="form-control" type="checkbox" v-model="selectAllChatQueues" disabled></input>
									<span>Selecionar todas</span>
								</div>
							</div>
							<multiselect v-model="selectedChatQueues" :options="chatQueuesList" :multiple="true" :close-on-select="false"
								:clear-on-select="false" select-label="Selecionar" deselect-label="Remover" selected-label="Selecionada"
								:preserve-search="true" placeholder="Selecione as filas" label="name" track-by="id"
								:preselect-first="true" :searchable="true" style="font-size: 12px;"
								disabled
							>
								<template slot="selection" slot-scope="{ values, search, isOpen }">
									<span class="multiselect__single"
										v-if="selectedChatQueues.length" 
										v-show="!isOpen">{{ selectedChatQueues.length }} {{ selectedChatQueues.length === 1 ? 'fila selecionada' : 'filas selecionadas' }}
									</span></template>
							</multiselect>
						</div>
						<div class="filter-group">
							<span>Modo de dados</span>
							<div class="type-select-group">
								<div class="radio-group">
									<input type="radio" data-type="horizontal" class="form-control" name="filter-select" id="date-filter"
										value="realtime" v-model="type">
									<label for="date-filter">Tempo Real</label>
								</div>
								<div class="radio-group">
									<input type="radio" data-type="horizontal" class="form-control" name="filter-select" id="date-filter"
										value="report" v-model="type">
									<label for="date-filter">Relatório</label>
								</div>
								<div class="date-group">
									<div>
										<span>De</span>
										<input type="date" class="form-control" :disabled="type === 'realtime'" v-model="start"></input>
									</div>
									<div>
										<span>Até</span>
										<input type="date" class="form-control" :disabled="type === 'realtime'" v-model="end"></input>
									</div>
								</div>
							</div>
						</div>
						<div class="button-group">
							<b-button @click="resetFilters()" variant="secondary"><i class="fas fa-refresh"></i>
								Resetar
							</b-button>
							<b-button @click="applyFilters()" variant="primary"><i class="fas fa-bit fa-check"></i>
								Aplicar
							</b-button>
						</div>
					</div>
					<b-button @click="closeFilters()" class="close-filter-button"><i class="fas fa-bit fa-times"></i>
						Fechar 
					</b-button>
				</b-card>
			</b-collapse>
		</div>
		<div v-if="isLoading" class="loading-container">
			<div class="loading-content">
				<i class="fas fa-spinner fa-pulse loading-icon"></i>
				<p class="loading-text">Carregando, por favor aguarde...</p>
			</div>
		</div>
		<div v-else class="dashboard-container">
			<div class="custom-panel left-panel">
				<div class="horizontal-container chart-sm">
					<div class="chart-container chart-lg no-overflow">
						<InfoCard :seriesTitle="'Ligações recebidas'" :data="chartData.cards.received" :seriesColor="'#023e8a'" />
					</div>
					<div class="chart-container chart-lg no-overflow">
						<InfoCard :seriesTitle="'Ligações atendidas'" :data="chartData.cards.answered" :seriesColor="'#0ead69'" />
					</div>
					<div class="chart-container chart-lg no-overflow">
						<InfoCard :seriesTitle="'Ligações abandonadas'" :data="chartData.cards.abandoned" :seriesColor="'#ef233c'" />
					</div>
					<div class="chart-container chart-lg no-overflow">
						<InfoCard :seriesTitle="'Ligações realizadas'" :data="chartData.cards.outgoing" :seriesColor="'#7b2cbf'" />
					</div>
				</div>
				<div class="chart-container chart-lg no-overflow">
					<OperatorsTable :data="chartData.operators" />
				</div>
				<div class="horizontal-container chart-lg"> <!-- Usar classe chart-md se descomentar a div da linha 142 -->
					<div class="chart-container chart-lg">
						<!-- <div class="toggle-chart-buttons">
							<div class="badge mode-icon" :title="dynamicChart.survey.mode === 'fixed' ? 'Modo Fixo' : 'Modo Automático'" @click="changeChartMode('survey')">
								<i 
									class="fas" 
									:class="{'fa-bar-chart': dynamicChart.survey.mode === 'fixed', 'fa-random': dynamicChart.survey.mode === 'auto'}"
								></i>
								{{ dynamicChart.survey.mode === 'fixed' ? 'Fixo' : 'Auto' }}
							</div>
							<div 
								class="badge change-icon"
								@click="changeChartDisplay('survey')"
							>
								<i class="fas fa-refresh"></i>Alternar
							</div>
						</div> -->
						<SatisfactionChart :data="chartData.survey.phone" :title="'Pesquisa de Satisfação - Telefonia'" />
						<!-- <AttendanceReasonChart v-if="dynamicChart.survey.display === 2" :data="chartData.reasons.phone" :title="'Motivo da Avaliação - Telefonia'" />
						<SatisfactionChart v-if="dynamicChart.survey.display === 3" :data="chartData.survey.chat" :title="'Pesquisa de Satisfação - Whatsapp'" />
						<AttendanceReasonChart v-if="dynamicChart.survey.display === 4" :data="chartData.reasons.chat" :title="'Motivo da Insatisfação - Whatsapp'" /> -->
					</div>
					<div class="chart-container chart-lg no-overflow">
						<!-- <AttendanceChannel v-if="dynamicChart.channels.display === 1" :data="chartData.channels" /> -->
						<CsatChart :data="chartData.survey.phone" :title="'CSAT - Telefonia'"/>
					</div>
				</div>
			</div>
			<div class="custom-panel right-panel">
				<div class="chart-container chart-lg">
					<ReceivedCallsChart :data="chartData.receivedCalls" />
				</div>
				<div class="chart-container chart-md">
					<div class="toggle-chart-buttons">
						<div class="badge mode-icon" :title="dynamicChart.channels.mode === 'fixed' ? 'Modo Fixo' : 'Modo Automático'" @click="changeChartMode('levels')">
							<i 
								class="fas" 
								:class="{'fa-bar-chart': dynamicChart.levels.mode === 'fixed', 'fa-random': dynamicChart.levels.mode === 'auto'}"
							></i>
							{{ dynamicChart.levels.mode === 'fixed' ? 'Fixo' : 'Auto' }}
						</div>
						<div 
							class="badge change-icon"
							@click="changeChartDisplay('levels')"
						>
							<i class="fas fa-refresh"></i>Alternar
						</div>
					</div>
					<ServiceLevelChart v-if="dynamicChart.levels.display === 1" :data="chartData.serviceLevel" />
					<AbandonedLevelChart v-if="dynamicChart.levels.display === 2" :data="chartData.abandonLevel"/>
					<!-- <CsatChart v-if="dynamicChart.levels.display === 3" :data="chartData.survey.phone" :title="'CSAT - Telefonia'"/> -->
					<!-- <CsatChart v-if="dynamicChart.levels.display === 4" :data="chartData.survey.chat" :title="'CSAT - Chat'"/> -->
				</div>
				<div class="chart-container chart-lg">
					<div class="toggle-chart-buttons">
						<div class="badge mode-icon" :title="dynamicChart.queue.mode === 'fixed' ? 'Modo Fixo' : 'Modo Automático'" @click="changeChartMode('queue')">
							<i 
								class="fas" 
								:class="{'fa-bar-chart': dynamicChart.queue.mode === 'fixed', 'fa-random': dynamicChart.queue.mode === 'auto'}"
							></i>
							{{ dynamicChart.queue.mode === 'fixed' ? 'Fixo' : 'Auto' }}
						</div>
						<div 
							class="badge change-icon"
							@click="changeChartDisplay('queue')"
						>
							<i class="fas fa-refresh"></i>Alternar
						</div>
					</div>
					<QueueTotals v-if="dynamicChart.queue.display === 1" :data="chartData.queues" />
					<QueueAvgTimeChart v-if="dynamicChart.queue.display === 2" :data="chartData.queues" />
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import ServiceLevelChart from './components/ServiceLevelChart.vue';
import AbandonedLevelChart from './components/AbandonedLevelChart.vue';
import QueueAvgTimeChart from './components/QueueAvgTimeChart.vue';
import QueueTotals from './components/QueueTotals.vue';
import ReceivedCallsChart from './components/ReceivedCallsChart.vue';
import OperatorsTable from './components/OperatorsTable.vue';
import SatisfactionChart from './components/SatisfactionChart.vue';
import AttendanceReasonChart from './components/AttendanceReasonChart.vue';
import AttendanceChannel from './components/AttendanceChannel.vue';
import Requests from './components/Requests.vue';
import InfoCard from './components/InfoCard.vue';
import CsatChart from './components/CsatChart.vue';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import moment from 'moment';

export default {
	data() {
		return {
			isPolling: false,
			isLoading: false,
			excelLoading: false,
			interval: 30000,
			error: null,
			intervalId: null,
			start: null,
			end: null,
			type: 'realtime',
			selectedProjects: [],
			projectsList: [],
			selectedQueues: [],
			selectedChatQueues: [],
			queuesList: [],
			allPhoneQueues: [],
			chatQueuesList: [],
			chartData: {
				cards: {
					answered: {},
					notAnswered: {},
					outgoing: {},
					received: {},
				},
				operators: {},
				serviceLevel: 0,
				abandonLevel: 0,
				queues: {},
				reasons: {
					phone: {},
					chat: {}
				},
				receivedCalls: {},
				survey: {
					phone: {},
					chat: {}
				},
				channels: {},
				requests: {
					channels: {},
					status: {}
				}
			},
			dynamicChart:{
				queue: {
					length: 2,
					display: 1,
					mode: 'auto',
					autoIntervalId: null,
					autoInterval: 13033
				},
				survey: {
					length: 4,
					display: 1,
					mode: 'auto',
					autoIntervalId: null,
					autoInterval: 13033
				},
				channels: {
					length: 3,
					display: 1,
					mode: 'auto',
					autoIntervalId: null,
					autoInterval: 13033
				},
				levels: {
					length: 2,
					display: 1,
					mode: 'auto',
					autoIntervalId: null,
					autoInterval: 13033
				}
			},
			selectAllPhoneQueues: false,
			selectAllChatQueues: false,
			selectAllProjects: false
		}
	},
	name: "Dashboard",
	components: {
		ServiceLevelChart,
		AbandonedLevelChart,
		QueueAvgTimeChart,
		ReceivedCallsChart,
		OperatorsTable,
		SatisfactionChart,
		AttendanceReasonChart,
		InfoCard,
		QueueTotals,
		AttendanceChannel,
		Requests,
		CsatChart
	},
	props: [],
	computed: {},
	async mounted() {
		await this.getUserQueues();
		await this.getProjects();
		await this.getUserChatQueues();
		await this.startPolling();

		const charts = Object.entries(this.dynamicChart)
		if(charts.length){
			charts.map(el => {
				if(el[1].mode === 'auto') this.startChartAutoMode(el[0])
			})
		}
	},
	beforeDestroy() {
		this.stopPolling()
		this.stopChartAutoMode()
	},
	methods: {
		async getUserQueues() {
			try {
				this.queuesList = [];
				await axios.get('/user-queues').then(({ data }) => {
					if (data?.length) {
						data.map(el => this.queuesList.push({ id: el.id, name: el.name }))
					}
					this.allPhoneQueues = [...this.queuesList];
					if (this.queuesList.length && !this.selectedQueues.length) {
						this.selectedQueues = this.queuesList
						this.selectAllPhoneQueues = true;
					}
				})
			} catch (err) {
				this.error = 'Erro ao obter filas de telefonia'
				console.error('Fetch queues error:', err)
			}
		},

		async getProjects() {
			try {
				this.projectsList = [];
				await axios.get('/listProjectsByUser').then(({ data }) => {
					if (Array.isArray(data) && data.length) {
						this.projectsList = data.map((project) => ({
							id: project.id,
							name: project.name,
							queues: Array.isArray(project.queues) ? project.queues.map(String) : []
						}));
					}
					if (this.projectsList.length && !this.selectedProjects.length) {
						this.selectedProjects = this.projectsList;
						this.selectAllProjects = true;
					}
				});
			} catch (err) {
				this.error = 'Erro ao obter projetos'
				console.error('Fetch projects error:', err)
			}
		},

		applyProjectFilter() {
			if (!this.selectedProjects.length) {
				this.queuesList = [...this.allPhoneQueues];
				this.selectedQueues = [...this.queuesList];
				this.selectAllPhoneQueues = true;
				return;
			}

			const queueIds = new Set();
			this.selectedProjects.forEach((project) => {
				(project.queues || []).forEach((queueId) => queueIds.add(String(queueId)));
			});

			this.queuesList = this.allPhoneQueues.filter((queue) => queueIds.has(String(queue.id)));
			this.selectedQueues = [...this.queuesList];
			this.selectAllPhoneQueues = this.queuesList.length > 0;
		},

		async getUserChatQueues() {
			try {
				this.chatQueuesList = [];
				await axios.get('/user-chat-queues').then(({ data }) => {
					if (data?.length) {
						data.map((el, index) => this.chatQueuesList.push({id: index, name:el}))
					}
					if (this.chatQueuesList.length && !this.selectedChatQueues.length) {
						this.selectedChatQueues = this.chatQueuesList
					}
				})
			} catch (err) {
				this.error = 'Erro ao obter filas de chat'
				console.error('Fetch chat queues error:', err)
			}
		},

		async fetchData(payload) {
			try {
				if(!this.isPolling){
					this.isLoading = true
				}

				this.error = null

				await axios.post('/dashboard-v2/getDashboardData', payload).then(({ data }) => {
					if (data && Object.keys(data).length) {
						this.chartData.cards = data.cards;
						this.chartData.operators = data.operators;
						this.chartData.serviceLevel = data.serviceLevel;
						this.chartData.abandonLevel = data.abandonLevel;
						this.chartData.queues = data.queues;
						this.chartData.reasons = data.reasons || {};
						this.chartData.receivedCalls = data.receivedCalls;
						this.chartData.survey = data.survey;
						this.chartData.channels = data.channels || {};
					}
				})
			} catch (err) {
				this.error = 'Erro ao carregar dados'
				console.error('Fetch data error:', err)
			} finally {
				this.isLoading = false
			}
		},

		async generateExcel(payload) {
			try {
				this.excelLoading = true;

				const payload = {
					start: this.start,
					end: this.end,
					type: this.type,
					selectedQueues: this.selectedQueues,
					selectedChatQueues: this.selectedChatQueues
				}

				let responseData = {};

				await axios.post('/dashboard-v2/getDetailedData', payload).then(({ data }) => {
					if (data && Object.keys(data).length) {
						responseData = data
					}
				})

				if (Object.keys(responseData).length) {
					const workbook = XLSX.utils.book_new();
					let headerOrder = [];

					Object.entries(responseData).forEach(([sheetName, dataArray]) => {
						let formattedSheetName = 'planilha';
						const parsedArray = [];

						if (!Array.isArray(dataArray) || !dataArray.length) return

						switch (sheetName) {
							case 'outgoingCalls':
								formattedSheetName = 'Ligações realizadas'

								headerOrder = [
									'Data',
									'Código',
									'Telefone',
									'Operador',
									'Ramal',
									'Tempo de Atendimento'
								];

								dataArray.map(el => {
									if(typeof el === 'object' && Object.keys(el).length){
										let recordObj = {}
										Object.entries(el).map(obj => {
											if(obj[0] === 'calldate'){
												recordObj.Data = moment(obj[1]).format('DD/MM/YYYY - HH:mm:ss')
											}

											if(obj[0] === 'dst'){
												recordObj.Código = obj[1]
											}

											if(obj[0] === 'destino'){
												recordObj.Telefone = obj[1]
											}

											if(obj[0] === 'operator_name'){
												recordObj.Operador = obj[1]
											}

											if(obj[0] === 'src'){
												recordObj.Ramal = obj[1]
											}

											if(obj[0] === 'duration'){
												recordObj['Tempo de Atendimento'] = moment.utc(obj[1] * 1000).format('HH:mm:ss');
											}
										})
										parsedArray.push(recordObj)
									}
								})

								break;
							case 'answeredCalls':
								formattedSheetName = 'Ligações atendidas'

								headerOrder = [
									'Data',
									'Telefone',
									'Operador',
									'Ramal',
									'Fila de Atendimento',
									'Tempo de Espera',
									'Tempo de Atendimento',
									'Avaliação',
								];

								dataArray.map(el => {
									if(typeof el === 'object' && Object.keys(el).length){
										let recordObj = {}
										Object.entries(el).map(obj => {
											if(obj[0] === 'time'){
												recordObj.Data = moment(obj[1]).format('DD/MM/YYYY - HH:mm:ss')
											}

											if(obj[0] === 'phone_number'){
												recordObj.Telefone = obj[1]
											}

											if(obj[0] === 'operator_name'){
												recordObj.Operador = obj[1]
											}

											if(obj[0] === 'agent'){
												recordObj.Ramal = obj[1]
											}
											
											if(obj[0] === 'queuename'){
												recordObj['Fila de Atendimento'] = obj[1]
											}

											if(obj[0] === 'data1'){
												recordObj['Tempo de Espera'] = moment.utc(obj[1] * 1000).format('HH:mm:ss');
											}

											if(obj[0] === 'data2'){
												recordObj['Tempo de Atendimento'] = moment.utc(obj[1] * 1000).format('HH:mm:ss');
											}

											if(obj[0] === 'nota'){
												let avaliacao;
												if(obj[1]){
													if(obj[1] == 1) avaliacao = 'Péssimo';
													if(obj[1] == 2) avaliacao = 'Ruim';
													if(obj[1] == 3) avaliacao = 'Regular';
													if(obj[1] == 4) avaliacao = 'Bom';
													if(obj[1] == 5) avaliacao = 'Ótimo';
												}
												recordObj.Avaliação = avaliacao
											}
										})
										parsedArray.push(recordObj)
									}
								})

								break;
							case 'notAnsweredCalls':
								formattedSheetName = 'Ligações perdidas'

								headerOrder = [
									'Data',
									'Telefone',
									'Operador',
									'Ramal',
									'Fila de Atendimento',
									'Tempo de Espera'
								];

								dataArray.map(el => {
									if(typeof el === 'object' && Object.keys(el).length){
										let recordObj = {}
										Object.entries(el).map(obj => {
											if(obj[0] === 'time'){
												recordObj.Data = moment(obj[1]).format('DD/MM/YYYY - HH:mm:ss')
											}

											if(obj[0] === 'phone_number'){
												recordObj.Telefone = obj[1]
											}

											if(obj[0] === 'operator_name'){
												recordObj.Operador = obj[1]
											}

											if(obj[0] === 'agent'){
												recordObj.Ramal = obj[1]
											}
											
											if(obj[0] === 'queuename'){
												recordObj['Fila de Atendimento'] = obj[1]
											}

											if(obj[0] === 'data1'){
												const duration = moment.duration(obj[1]);
												recordObj['Tempo de Espera'] = moment.utc(duration.asMilliseconds()).format('HH:mm:ss');
											}
										})
										parsedArray.push(recordObj)
									}
								})

								break;
							case 'abandonedCalls':
								formattedSheetName = 'Ligações abandonadas'

								headerOrder = [
									'Data',
									'Telefone',
									'Fila de Atendimento',
									'Posição Inicial na Fila',
									'Posição Final na Fila',
									'Tempo de Espera',
								];

								dataArray.map(el => {
									if(typeof el === 'object' && Object.keys(el).length){
										let recordObj = {}
										Object.entries(el).map(obj => {
											if(obj[0] === 'time'){
												recordObj.Data = moment(obj[1]).format('DD/MM/YYYY - HH:mm:ss')
											}

											if(obj[0] === 'phone_number'){
												recordObj.Telefone = obj[1]
											}
											
											if(obj[0] === 'queuename'){
												recordObj['Fila de Atendimento'] = obj[1]
											}
											
											if(obj[0] === 'data2'){
												recordObj['Posição Inicial na Fila'] = obj[1]
											}

											if(obj[0] === 'data1'){
												recordObj['Posição Final na Fila'] = obj[1]
											}

											if(obj[0] === 'data3'){
												recordObj['Tempo de Espera'] = moment.utc(obj[1] * 1000).format('HH:mm:ss');
											}
										})
										parsedArray.push(recordObj)
									}
								})

								break;
							// case 'whatsapp': 
							// 	formattedSheetName = 'Whatsapp'
								
							// 	headerOrder = [
							// 		'Data',
							// 		'Protocolo',
							// 		'Telefone',
							// 		'CNPJ',
							// 		'Banco',
							// 		'Agência',
							// 		'Nome do Ponto',
							// 		'Nome',
							// 		'Cliente',
							// 		'Fila de Atendimento',
							// 		'Operador',
							// 		'Avaliação',
							// 		'Motivo da Insatisfação'
							// 	];
								
							// 	dataArray.map(el => {
							// 		if(typeof el === 'object' && Object.keys(el).length){
							// 			let recordObj = {}
							// 			Object.entries(el).map(obj => {
							// 				if(obj[0] === 'created_at'){
							// 					recordObj.Data = moment(obj[1]).format('DD/MM/YYYY - HH:mm:ss')
							// 				}
										
							// 				if(obj[0] === 'protocol'){
							// 					recordObj.Protocolo = obj[1]
							// 				}
										
							// 				if(obj[0] === 'client_id'){
							// 					recordObj.Telefone = obj[1].indexOf('@') !== -1 ? obj[1].substring(0, obj[1].indexOf('@')) : obj[1];
							// 				}
														
							// 				if(obj[0] === 'cnpj'){
							// 					recordObj.CNPJ = obj[1]
							// 				}
										
							// 				if(obj[0] === 'bankName'){
							// 					recordObj.Banco = obj[1]
							// 				}
										
							// 				if(obj[0] === 'agencia'){
							// 					recordObj.Agência = obj[1]
							// 				}
										
							// 				if(obj[0] === 'clientInfo'){
							// 					recordObj['Nome do Ponto'] = obj[1].NomePonto
							// 				}
											
							// 				if(obj[0] === 'name'){
							// 					recordObj.Nome = obj[1]
							// 				}
										
							// 				if(obj[0] === 'client'){
							// 					recordObj.Cliente = obj[1]
							// 				}
										
							// 				if(obj[0] === 'queue'){
							// 					recordObj['Fila de Atendimento'] = obj[1]
							// 				}
										
							// 				if(obj[0] === 'operador_nome'){
							// 					recordObj.Operador = obj[1]
							// 				}
										
							// 				if(obj[0] === 'avaliacao'){
							// 					recordObj.Avaliação = obj[1]
							// 				}
										
							// 				if(obj[0] === 'motivo'){
							// 					recordObj['Motivo da Insatisfação'] = obj[1]
							// 				}
							// 			})
							// 			parsedArray.push(recordObj)
							// 		}
							// 	})
							// 	break;
							default:
								break;
						}

						if (Array.isArray(parsedArray) && parsedArray.length) {
							const worksheet = XLSX.utils.json_to_sheet(parsedArray, { header: headerOrder });
							XLSX.utils.sheet_add_aoa(worksheet, [headerOrder], { origin: "A1" });
							worksheet['!cols'] = headerOrder.map(() => ({ wch: 19 }));
							worksheet['!autofilter'] = { ref: worksheet['!ref'] };
							XLSX.utils.book_append_sheet(workbook, worksheet, formattedSheetName);
						}
					});
				
					XLSX.writeFile(workbook, 'dashboard-dados.xlsx');
				}
			} catch (err) {
				this.error = 'Erro ao gerar excel'
				console.error('Generate Excel error:', err)
			} finally {
				this.excelLoading = false
			}
		},

		startPolling() {
			const payload = {
				start: this.start,
				end: this.end,
				type: this.type,
				selectedQueues: this.selectedQueues,
				selectedChatQueues: this.selectedChatQueues
			}
			this.stopPolling()
			this.fetchData({...payload})

			this.isPolling = true;

			if (this.isPolling) {
				this.intervalId = setInterval(() => {
					this.fetchData({...payload})
				}, this.interval)
			}
		},

		stopPolling() {
			this.isPolling = false;
			if (this.intervalId) {
				clearInterval(this.intervalId)
				this.intervalId = null
			}
		},

		restartPolling() {
			if (this.isPolling) {
				this.startPolling()
			}
		},

		togglePolling() {
			this.isPolling = !this.isPolling
			if (this.isPolling) {
				this.startPolling()
			} else {
				this.stopPolling()
			}
		},

		resetChartData() {
			this.chartData = {
				cards: {
					answered: {},
					notAnswered: {},
					outgoing: {},
					received: {},
				},
				operators: {},
				serviceLevel: 0,
				abandonLevel: 0,
				queues: {},
				reasons: {
					phone: {},
					chat: {}
				},
				receivedCalls: {},
				survey: {
					phone: {},
					chat: {}
				},
				channels: {},
				requests: {
					channels: {},
					status: {}
				}
			}
		},

		async applyFilters(){
			if (!this.selectedQueues.length) {
		    	Swal.fire({
		    	    type: 'error',
		    	    title: 'Atenção',
		    	    text: 'Você precisa selecionar pelo menos uma fila de telefonia.',
		    	    confirmButtonText: 'OK'
		    	});
    			return;
			}
			// if (!this.selectedChatQueues.length) {
		    // 	Swal.fire({
		    // 	    type: 'error',
		    // 	    title: 'Atenção',
		    // 	    text: 'Você precisa selecionar pelo menos uma fila de chat.',
		    // 	    confirmButtonText: 'OK'
		    // 	});
    		// 	return;
			// }
			if(this.type === 'report' && (!this.start || !this.end)){
				Swal.fire({
		        	type: 'error',
		        	title: 'Atenção',
		        	text: 'Você precisa selecionar um período para buscar o relatório!',
		        	confirmButtonText: 'OK'
		    	});
    			return;
			}

			const payload = {
				start: this.start,
				end: this.end,
				type: this.type,
				selectedQueues: this.selectedQueues,
				selectedChatQueues: this.selectedChatQueues
			}

			if (this.type === 'realtime') {
				await this.startPolling()
			} else {
				await this.stopPolling();
				await this.fetchData({...payload});
			}
			this.closeFilters()
		},

		async resetFilters(){
			this.type = 'realtime';
			this.selectedProjects = [];
			this.queuesList = [...this.allPhoneQueues];
			this.selectedQueues = this.queuesList;
			this.selectedChatQueues = this.chatQueuesList;
			this.start = null;
			this.end = null;
			this.applyFilters()
		},

		closeFilters() {
			this.$root.$emit('bv::toggle::collapse', 'collapse-dashboard-filters')
		},

		changeChartMode(type){
			if(this.dynamicChart[type].mode === 'fixed'){
				this.dynamicChart[type].mode = 'auto';
				this.startChartAutoMode(type);
			} else if(this.dynamicChart[type].mode === 'auto') {
				this.dynamicChart[type].mode = 'fixed';
				this.stopChartAutoMode(type);
			}
		},

		changeChartDisplay(type){
			const length = this.dynamicChart[type].length;
			if(this.dynamicChart[type].display < length){
				this.dynamicChart[type].display++
			} else {
				this.dynamicChart[type].display = 1;
			}
		},

		startChartAutoMode(type) {
			this.stopChartAutoMode(type);
			
			if (this.dynamicChart[type].mode === 'auto') {
				this.dynamicChart[type].autoIntervalId = setInterval(() => {
					this.changeChartDisplay(type);
				}, this.dynamicChart[type].autoInterval);
			}
		},

		stopChartAutoMode(type) {
			if (this.dynamicChart[type].autoIntervalId) {
				clearInterval(this.dynamicChart[type].autoIntervalId);
				this.dynamicChart[type].autoIntervalId = null;
			}
		},
	},
	watch: {
		selectedProjects() {
			this.applyProjectFilter();
		},
		selectAllPhoneQueues(val){
			if(val){
				this.selectedQueues = this.queuesList;
			} else {
				this.selectedQueues = [];
			}
		},
		selectAllChatQueues(val){
			if(val){
				this.selectedChatQueues = this.chatQueuesList;
			} else {
				this.selectedChatQueues = [];
			}
		},
		selectAllProjects(val){
			if(val){
				this.selectedProjects = this.projectsList;
			} else {
				this.selectedProjects = [];
			}
		}
	}
}
</script>

<style lang="scss">
.custom-topbar {
	height: 40px;
	margin: 5px;
	display: flex;
	justify-content: space-between;

	button {
		border-radius: 10px !important;
		font-weight: bold;
		box-shadow: 1px 1px 3px 0px gray;

		text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.7) !important;
	}

	.mode-indicator {
		color: #1c869a;
    	font-size: medium;
    	padding: 10px 5px;
    	align-items: center;
    	display: flex;
		gap: 5px;

		span {
			font-weight: bold;
		}

		.realtime {
			color: #cf1111;
		}

		.report {
			color: goldenrod;
		}
	}
}

.collapse-wrapper {
	position: absolute;
	top: 65px; // A partir da topbar
	left: 0;
	width: 100vw;
	z-index: 1000;

	.filters-collapse {
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
		border-bottom: 1px solid #dee2e6;

		.filters-card {
			.card-body {
				padding: 0;
			}

			margin: 0;
			height: fit-content;
			background-color: #e9e9e9f5;
			display: flex;
			flex-direction: column;

			.filters-content {
				padding: 20px;
				display: flex;
				gap: 20px;
				width: 100%;

				.button-group {
					display: flex;
					flex-direction: column;
					flex: 1;
					gap: 20px;
					justify-content: center;

					button {
						padding: 5px 10px;
						border-radius: 10px !important;
						font-weight: bold;
						box-shadow: 1px 1px 3px 0px gray;

						text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.7) !important;
    
    					i {
    					    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.7) !important;
    					}
					}
				}

				.filter-group {
					display: flex;
					flex-direction: column;
					flex: 3;
					background-color: #f5f5f5;
					border-radius: 10px;
					padding: 5px 15px;
					gap: 15px;
					align-items: flex-start;
					justify-content: flex-start;
					box-shadow: 1px 1px 7px 0px gray;

					
					span {
						font-size: 14px;
						font-weight: bold;
						white-space: nowrap;
						
						.multiselect__single {
							font-size: 14px;
							color: #333;
							font-weight: 500;
						}
					}

					.filter-checkbox-group {
						display: flex;
						width: 100%;
						justify-content: space-between;

						.checkbox-input-group {
							display: flex;
							align-items: center;
							gap: 5px;

							input {
								width: 16px;
								height: 16px;
								cursor: pointer;
								box-shadow: none;
								
								&:focus {
									outline: none
								}
							}
						}
					}

					.type-select-group {
						display: flex;
						justify-content: flex-start;
						gap: 15px;

						.radio-group {
							display: flex;
							flex: 1;
							gap: 5px;
							align-items: center;

							label {
								margin: 0 !important;
								white-space: nowrap;
							}

							input {
								width: 20px;
								cursor: pointer;

								&:focus {
									outline: none;
									box-shadow: none;
								}
							}
						}
					}


					.date-group {
						display: flex;
						flex: 1;
						gap: 5px;
						border-left: 3px solid #8080804a;
						padding: 0 10px;

						div {
							display: flex;
							gap: 7px;
							align-items: center;
						}

						input {
							border-radius: 5px !important;
						}
					}
				}

			}
			.close-filter-button {
				background: none;
    			color: #cc4141;
    			padding: 5px 10px;
    			border-radius: 10px !important;
    			font-weight: bold;
    			border: none;
    			width: 100%;
				transition: 0.4s;

				&:hover {
					background-color: rgba(211, 211, 211, 0.479);
				}
			}
		}
	}
}

.loading-container {
	height: calc(100vh - 140px);
	display: flex;
	justify-content: center;
	border: 1px solid lightgray;
	box-shadow: 1px 1px 4px 0 lightgray;
	border-radius: 10px;

	.loading-content {
		display: flex;
		flex: 1;
		flex-direction: column;
		align-items: center;
		align-self: center;
		padding: 40px;
	}

	.loading-icon {
		font-size: 48px;
		color: #1c869a;
		margin-bottom: 20px;
	}

	.loading-text {
		font-size: 24px;
		color: #495057;
		margin: 0;
		font-weight: bold;
		text-align: center;
	}
}

.dashboard-container {
	height: calc(100vh - 140px);
	display: grid;
	grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
	max-width: 100vw;
	overflow: hidden;

	@media (max-width: 1000px) {
		grid-template-columns: minmax(0, 1fr);
		grid-template-rows: auto auto;
	}

	.custom-panel {
		display: flex;
		flex-direction: column;
		max-height: calc(100vh - 150px);

		.chart-container {
			border: 1px solid lightgray;
			box-shadow: 1px 1px 4px 0 lightgray;
			padding: 2px;
			border-radius: 10px;
			margin: 4px;
			overflow-y: auto;
			overflow-x: hidden;
			position: relative;
			display: flex;
			flex-direction: column;

			&::-webkit-scrollbar {
				padding: 1px;
			}

			&::-webkit-scrollbar-thumb {
				background: #7db6c9;
				border-radius: 5px;
			}

			scrollbar-width: thin;
			scrollbar-color: #7db6c9 transparent;

			.toggle-chart-buttons {
				display: flex;
				flex-direction: column;
    			gap: 3px;
				align-items: flex-start;
    			position: absolute;
    			z-index: 99;
    			width: fit-content;
    			padding: 3px;

				div {
					opacity: 0.4;
    				cursor: pointer;
    				color: white;
    				width: 70px;
    				display: flex;
    				gap: 3px;
    				justify-content: center;
					transition: 0.4s ease-in-out;
				}
				
				.mode-icon {
					&:hover {
						opacity: 1;
					}

    				background-color: #cf1111;
				}

				.change-icon {
					&:hover {
						opacity: 1;
					}
					background-color: #1c869a;
				}
			}
		}

		.horizontal-container {
			display: flex;
			gap: 10px;
		}


		.chart-lg {
			flex: 3;
		}

		.chart-md {
			flex: 2;
		}

		.chart-sm {
			flex: 1;
		}

		.no-overflow {
			overflow: hidden !important;
		}
	}
}

// Adicionar responsividade para o collapse
@media (max-width: 768px) {
	.collapse-wrapper {
		.filters-collapse {
			.filters-card {
				.filters-content {
					padding: 15px;
				}
			}
		}
	}
}
</style>